/* eslint-disable react/jsx-no-bind */
import SidedNav, { SidedNavProps } from 'shared-components/ui/SidedNav'
import React from 'react'

type SidedCategoryMenuProps = Omit<SidedNavProps, 'renderItem'>

const SidedCategoryMenu: React.VFC<SidedCategoryMenuProps> = props => <SidedNav {...props} />

export default SidedCategoryMenu
